import React, { useEffect, useState } from "react";
import { all_routes } from "../router/all_routes";
import { useNavigate, useParams } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LANG } from "../../constants/language";
import { resetPassword } from "../../services/auth.service";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const navigate = useNavigate();
  const route = all_routes;
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  console.log("Token from URL:", token);
  const isTokenInvalid = !token || token.trim() === "";

  useEffect(() => {
    if (isTokenInvalid) {
      setHasErrors("The link you used is invalid");
    }
  }, [isTokenInvalid]);

  const [hasErrors, setHasErrors] = useState<string | undefined>(
    isTokenInvalid ? "The link you used is invalid" : undefined
  );

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible((prev) => !prev);
  };

  const goToLogin = () => {
    navigate(route.login);
  };

  const changePasswordSchema = Yup.object().shape({
    new_password: Yup.string()
      .required(LANG.PASSWORD_IS_REQUIRED)
      .min(8, LANG.PASSWORD_MIN_LENGTH)
      .matches(/[A-Z]/, LANG.PASSWORD_UPPERCASE)
      .matches(/[a-z]/, LANG.PASSWORD_LOWERCASE)
      .matches(/[0-9]/, LANG.PASSWORD_NUMBER)
      .matches(/[@#%!-]/, LANG.PASSWORD_SYMBOL),
    confirm_password: Yup.string()
      .required(LANG.CONFIRM_PASSWORD_IS_REQUIRED)
      .oneOf([Yup.ref("new_password")], LANG.PASSWORDS_MUST_MATCH),
  });

  const formik = useFormik({
    initialValues: {
      new_password: "",
      confirm_password: "",
    },
    validationSchema: changePasswordSchema,

    onSubmit: async (values, { setSubmitting }) => {
      if (isTokenInvalid) {
        setSubmitting(false);
        return; // Prevent submission if token is invalid
      }

      setLoading(true);
      try {
        const result = await resetPassword(token, {
          new_password: values.new_password,
        });
        toast.success(result.data?.message);
        navigate(route.successMessage, { state: { isLogin: false } });
        setSubmitting(false);
      } catch (error) {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.error || LANG.UNEXPECTED_ERROR);
        }
        setSubmitting(false);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="main-wrapper authendication-pages newPassword-page">
      <div className="content">
        <div className="container wrapper no-padding">
          <div className="row no-margin vph-100">
            <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
              <div className="banner-bg banner-bg-1 login">
                <div className="row h100 pb-0">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row h-100">
                      <div className="col-md-12 h-100">
                        <img
                          src="/assets/img/authImg.jpg"
                          className="object-fit-cover h-100 img-fluid w-100"
                          alt="authImg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12  col-lg-4 no-padding">
              <div className="dull-pg h-100">
                <div className="row no-margin vph-100 h-100 d-flex align-items-top justify-content-center">
                  <div className="col-sm-12 col-md-12 col-lg-12 mx-auto">
                    <div className="shadow-card">
                      <div className="shadow-card-inner">
                        <header className="text-center position-relative">
                          <ImageWithBasePath
                            src="assets/img/logo.svg"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </header>

                        <h2 className="text-center">Reset Password</h2>

                        {!hasErrors && (
                          <p className="text-center">
                            Please enter your new password{" "}
                          </p>
                        )}

                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            <form onSubmit={formik.handleSubmit}>
                              {hasErrors && (
                                <div className="text-center m-4 pb-5 pt-5">
                                  <h4 className="text-danger">{hasErrors}</h4>
                                </div>
                              )}

                              {!isTokenInvalid && (
                                <>
                                  <div className="form-group">
                                    <label> Password</label>
                                    <div className="pass-group group-img  iconLeft email position-relative">
                                      <i
                                        className={`toggle-password ${showPassword ? "feather-eye" : "feather-eye-off"}`}
                                        onClick={togglePasswordVisibility}
                                      />
                                      <input
                                        type={
                                          showPassword ? "text" : "password"
                                        }
                                        name="new_password"
                                        value={formik.values.new_password}
                                        onChange={formik.handleChange}
                                        id="newpassword"
                                        placeholder="Enter your password"
                                        className={`form-control commonInput pass-confirm ${formik.touched.new_password && formik.errors.new_password ? "is-invalid" : ""}`}
                                      />

                                      {formik.touched.new_password &&
                                        formik.errors.new_password && (
                                          <div className="invalid-feedback">
                                            {formik.errors.new_password}
                                          </div>
                                        )}
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <label>Confirm Password</label>
                                    <div className="pass-group group-img  iconLeft email position-relative">
                                      <i
                                        className={`toggle-password ${confirmPasswordVisible ? "feather-eye" : "feather-eye-off"}`}
                                        onClick={
                                          toggleConfirmPasswordVisibility
                                        }
                                      />
                                      <input
                                        type={
                                          confirmPasswordVisible
                                            ? "text"
                                            : "password"
                                        }
                                        name="confirm_password"
                                        value={formik.values.confirm_password}
                                        onChange={formik.handleChange}
                                        id="newpassword"
                                        placeholder="Confirm your new password"
                                        className={`form-control commonInput pass-confirm ${formik.touched.confirm_password && formik.errors.confirm_password ? "is-invalid" : ""}`}
                                      />

                                      {formik.touched.confirm_password &&
                                        formik.errors.confirm_password && (
                                          <div className="invalid-feedback">
                                            {formik.errors.confirm_password}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </>
                              )}

                              {!hasErrors && (
                                <button
                                  type="submit"
                                  className="btn btn-primary primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                                  disabled={loading}
                                >
                                  {loading
                                    ? "Processing..."
                                    : "Update Password"}
                                </button>
                              )}

                              {hasErrors && (
                                <button
                                  type="submit"
                                  onClick={goToLogin}
                                  className="btn btn-primary primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                                  disabled={loading}
                                >
                                  {loading ? "Processing..." : "Go to Login"}
                                </button>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
